"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const parseDateTime_1 = __importDefault(require("../parseDateTime"));
// Takes a Date or string to convert to one
// Dates are always localized
// Returned Date is as well, but acts like it's UTC
const getUTCDate = (dateTime) => {
    const parsedDate = parseDateTime_1.default(dateTime);
    const utcDate = new Date(parsedDate.getUTCFullYear(), parsedDate.getUTCMonth(), parsedDate.getUTCDate(), parsedDate.getUTCHours(), parsedDate.getUTCMinutes(), parsedDate.getUTCSeconds(), parsedDate.getUTCMilliseconds());
    return utcDate;
};
exports.default = getUTCDate;
